/**
 * Top-level fallback for the Sentry.ErrorBoundary wrapping <App> in main.tsx —
 * an unhandled render error anywhere in the tree lands here instead of a
 * blank white screen. Deliberately generic (no /apply or /admin styling
 * assumption): this is the last resort when something above it already
 * broke, matching the plain-text "Something went wrong" tone used elsewhere
 * (e.g. AuthErrorScreen).
 */
export function ErrorFallback() {
  return (
    <div
      className="flex flex-col items-center justify-center"
      style={{
        minHeight: '100svh',
        background: 'var(--color-surface-base)',
        padding: 'var(--spacing-6)',
      }}
    >
      <p
        style={{
          fontFamily: 'var(--font-body)',
          fontSize: 'var(--text-body-md)',
          color: 'var(--color-error-text)',
          textAlign: 'center',
          maxWidth: '420px',
          marginBottom: 'var(--spacing-6)',
        }}
      >
        Something went wrong. Please try reloading the page.
      </p>
      <button
        type="button"
        onClick={() => window.location.reload()}
        style={{
          appearance: 'none',
          background: 'none',
          border: 0,
          cursor: 'pointer',
          fontFamily: 'var(--font-body)',
          fontSize: 'var(--text-body-sm)',
          fontWeight: 'var(--weight-semibold)',
          color: 'var(--color-action-primary)',
          textDecoration: 'none',
          padding: 0,
        }}
      >
        Reload
      </button>
    </div>
  );
}
